// src/pages/History/AncientHistory/HistoryPageHellenistic.js
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Classical_Antiquity_-_Hellenistic_World.png';

export default function HistoryPageHellenistic() {
  return (
    <TopicPage
      topicKey="Hellenistic World"
      title="History: Hellenistic World"
      backgroundImage={bg}
      startRoute="/History-Hellenistic-World-Go"
      scrollLabels={[
        "Alexander the Great",
        "Cultural Blending",
        "Science and Cities",
      ]}
        backRoute="/history-Classical-Antiquity"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}